module.exports = __webpack_public_path__ + "c9afbd5e4c79fec47d108ba655925772.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Auth/assets/4-cash-back.svg
// module id = ./app/containers/Auth/assets/4-cash-back.svg
// module chunks = 35